module.exports = __webpack_public_path__ + "img/大眼睛恐龙公仔.de5bcf8b.jpg";